type _blindStructure = {
  key: any;
  title: string;
  items: string[];
  lightColor?: string;
  darkColor?: string;
};
type _blindStructureLevel =
  | {
      level: number;
      smallBlind: number;
      bigBlind: number;
      ante: number;
      duration: number;
    }
  | {
      level: 'break';
      duration: number;
    };

type _blindStructurePreset = {
  name: string;
  levels: _blindStructureLevel[];
};
export const BLIND_STRUCTURE_DEFAULTS: { [key: number]: _blindStructure } = {
  1000: {
    key: 1000,
    title: '1,000',
    items: [
      '5-10',
      '10-20',
      '20-40',
      '40-80',
      'Break',
      '50-100',
      '75-100',
      '100-200',
      '150-200',
      'Break',
      '200-400',
      '300-600',
      '400-800',
      '500-1,000',
      'Break',
      '1,000-2,000',
      '2,000-4,000',
      '3,000-6,000',
    ],
    lightColor: 'blue.100',
    darkColor: 'blue.400',
  },
  2000: {
    key: 2000,
    title: '2,000/5,000',
    items: [
      '25-50',
      '50-100',
      '100-200',
      '200-400',
      'Break',
      '300-600',
      '400-800',
      '500-1,000',
      '1,000-2,000',
      'Break',
      '2,000-4,000',
      '3,000-6,000',
      '4,000-8,000',
      '5,000-10,000',
      'Break',
      '6,000-12,000',
      '7,000-14,000',
      '8,000-16,000',
    ],
    lightColor: 'green.100',
    darkColor: 'green.400',
  },
  5000: {
    key: 5000,
    title: '2,000/5,000',
    items: [
      '25-50',
      '50-100',
      '100-200',
      '200-400',
      'Break',
      '300-600',
      '400-800',
      '500-1,000',
      '1,000-2,000',
      'Break',
      '2,000-4,000',
      '3,000-6,000',
      '4,000-8,000',
      '5,000-10,000',
      'Break',
      '6,000-12,000',
      '7,000-14,000',
      '8,000-16,000',
    ],
    lightColor: 'green.100',
    darkColor: 'green.400',
  },
  10000: {
    key: 10000,
    title: '10,000',
    items: [
      '100-200',
      '200-400',
      '300-600',
      '400-800',
      'Break',
      '500-1,000',
      '1,000-2,000',
      '2,000-4,000',
      '3,000-6,000',
      'Break',
      '4,000-8,000',
      '5,000-10,000',
      '6,000-12,000',
      '7,000-14,000',
      'Break',
      '8,000-16,000',
      '9,000-18,000',
      '10,000-20,000',
    ],
    lightColor: 'orange.100',
    darkColor: 'orange.400',
  },
};

export const BLIND_STRUCTURE_PRESETS: _blindStructurePreset[] = [
  {
    name: 'Standard',
    levels: [
      { level: 1, smallBlind: 25, bigBlind: 50, ante: 0, duration: 30 },
      { level: 2, smallBlind: 50, bigBlind: 100, ante: 0, duration: 30 },
      { level: 3, smallBlind: 75, bigBlind: 150, ante: 25, duration: 30 },
      { level: 4, smallBlind: 100, bigBlind: 200, ante: 25, duration: 30 },
      { level: 5, smallBlind: 150, bigBlind: 300, ante: 50, duration: 30 },
      { level: 6, smallBlind: 200, bigBlind: 400, ante: 50, duration: 30 },
      { level: 7, smallBlind: 300, bigBlind: 600, ante: 75, duration: 30 },
      { level: 8, smallBlind: 400, bigBlind: 800, ante: 75, duration: 30 },
      { level: 'break', duration: 5 },
      { level: 9, smallBlind: 500, bigBlind: 1000, ante: 100, duration: 30 },
      { level: 10, smallBlind: 600, bigBlind: 1200, ante: 100, duration: 30 },
      { level: 11, smallBlind: 800, bigBlind: 1600, ante: 200, duration: 30 },
      { level: 12, smallBlind: 1000, bigBlind: 2000, ante: 200, duration: 30 },
      { level: 13, smallBlind: 1500, bigBlind: 3000, ante: 300, duration: 30 },
      { level: 14, smallBlind: 2000, bigBlind: 4000, ante: 400, duration: 30 },
      { level: 15, smallBlind: 3000, bigBlind: 6000, ante: 500, duration: 30 },
    ],
  },
  {
    name: 'Turbo',
    levels: [
      { level: 1, smallBlind: 25, bigBlind: 50, ante: 0, duration: 20 },
      { level: 2, smallBlind: 50, bigBlind: 100, ante: 0, duration: 20 },
      { level: 3, smallBlind: 75, bigBlind: 150, ante: 25, duration: 20 },
      { level: 4, smallBlind: 100, bigBlind: 200, ante: 25, duration: 20 },
      { level: 5, smallBlind: 150, bigBlind: 300, ante: 50, duration: 20 },
      { level: 6, smallBlind: 200, bigBlind: 400, ante: 50, duration: 20 },
      { level: 7, smallBlind: 300, bigBlind: 600, ante: 75, duration: 20 },
      { level: 8, smallBlind: 400, bigBlind: 800, ante: 75, duration: 20 },
      { level: 9, smallBlind: 500, bigBlind: 1000, ante: 100, duration: 20 },
      { level: 10, smallBlind: 600, bigBlind: 1200, ante: 100, duration: 20 },
      { level: 11, smallBlind: 800, bigBlind: 1600, ante: 200, duration: 20 },
      { level: 12, smallBlind: 1000, bigBlind: 2000, ante: 200, duration: 20 },
      { level: 13, smallBlind: 1500, bigBlind: 3000, ante: 300, duration: 20 },
      { level: 14, smallBlind: 2000, bigBlind: 4000, ante: 400, duration: 20 },
      { level: 15, smallBlind: 3000, bigBlind: 6000, ante: 500, duration: 20 },
    ],
  },
  {
    name: 'Custom',
    levels: [
      { level: 1, smallBlind: 25, bigBlind: 50, ante: 0, duration: 15 },
      { level: 2, smallBlind: 50, bigBlind: 100, ante: 0, duration: 15 },
      { level: 3, smallBlind: 75, bigBlind: 150, ante: 25, duration: 15 },
      { level: 4, smallBlind: 100, bigBlind: 200, ante: 25, duration: 15 },
      { level: 5, smallBlind: 150, bigBlind: 300, ante: 50, duration: 15 },
      { level: 6, smallBlind: 200, bigBlind: 400, ante: 50, duration: 15 },
      { level: 7, smallBlind: 300, bigBlind: 600, ante: 75, duration: 15 },
      { level: 8, smallBlind: 400, bigBlind: 800, ante: 75, duration: 15 },
      { level: 9, smallBlind: 500, bigBlind: 1000, ante: 100, duration: 15 },
      { level: 10, smallBlind: 600, bigBlind: 1200, ante: 100, duration: 15 },
      { level: 11, smallBlind: 800, bigBlind: 1600, ante: 200, duration: 15 },
      { level: 12, smallBlind: 1000, bigBlind: 2000, ante: 200, duration: 15 },
      { level: 13, smallBlind: 1500, bigBlind: 3000, ante: 300, duration: 15 },
      { level: 14, smallBlind: 2000, bigBlind: 4000, ante: 400, duration: 15 },
      { level: 15, smallBlind: 3000, bigBlind: 6000, ante: 500, duration: 15 },
    ],
  },
];
